<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">ACKNOWLEDGEMENTS</p>
<p class="noindent">Composing historical nonfiction is rarely a sole endeavor. Many professionals assisted in directing me to research sources, and I remain grateful and in their debt, especially to staff at the following libraries: the Town of Yarmouth, Sturgis Library, Boston Public Library, Barnstable Superior Court and Barnstable Law Library.</p>
<p class="indent">The Massachusetts Archives in Dorchester is one of the Commonwealth’s hidden gems, where William Milhomme and Timothy M. Jones provided crucial assistance regarding Mr. Snow’s prison and parole records. Attorney Richard Banks of the Parole Division of the Commonwealth Department of Corrections steered me in the right direction on a document search.</p>
<p class="indent">I am indebted to Ira Silverman, PhD, who composed the foreword, and to E. Josh Albright, who helped locate newspaper articles. John Sears Jr. of South Yarmouth told me the exact site of the murder. Nancy Thacher Reid of South Dennis shared historical notes on events of 1899. I am grateful to the Historical Society of Old Yarmouth, Dennis Historical Society and the Barnstable Historical Society, which granted permission to use images from their collections, although I regret that no images were available of the individuals about whom I have written. My thanks as well go to Peter Owens, PhD, University of Massachusetts Dartmouth, for his years of encouragement and support.</p>
<p class="indent">Most of all, my deepest thanks go to my children, Katherine Margaret and Thomas, who often patiently waited until Mom finished her work, and to my husband, Dan, for his support through the years.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?d725ca4a